import React, { useState, useRef, useEffect, createContext, useContext } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { NProgress } from "../Components/Loadspinner";
import axios from "axios";




// Basically I'm doing one thing that is meant to be multiple things in other components

export let MyContext = createContext()   // This is the minor that gets imported in other componenets


function MyContextProvider({children}){    // Children here means children components

    let [isAuthenticated, setIsAuthenticated] = useState(undefined)
    let [successLogin, setSuccessLogin] = useState(false)
    let [splashLoading, setSplashLoading] = useState(true) //Thus from wherever we can authenticate while displaying splashLoader


    //let [username, setUserName] = useState()
    let [userInfo, setUserInfo] = useState()
    let [searchResults, setSearchResults] = useState()
    let [selected, setSelected] = useState("All")
    let [colorMode, setColorMode] = useState("Light")
    let {isOpen:isOpenDrawer, onClose:onCloseDrawer, onOpen:onOpenDrawer} = useDisclosure()
    // For Playlist create modal
    let [isOnline, setIsOnline] = useState(navigator.onLine)
    let [doneUpdating, setDoneUpdating] = useState(false)
    

    let [category, setCategory] = useState(0)
    let [nextPageToken, setNextPageToken] = useState("")
    

    let toggleColorMode = ()=>{
        setColorMode((prev=> prev==="Light"? "Dark":"Light"))
    }


    //Thus for remember last page visited
    let setAttemptedPathToSession = (path)=>{
    sessionStorage.setItem("attemptedPath", path)
    }


    let consumeAttemptedPath = ()=>{
        const path = sessionStorage.getItem("attemptedPath")
        //set it back to null so it doesn't linger around on next login. It's suppose to be one time login thing
        // using function from context because navigate overide setState and wont let it fire
        sessionStorage.removeItem("attemptedPath") 

        return path;
    }



    function getCSRFToken(){
    let cookieValue = document.cookie.match(/csrftoken=([^ ;])+/)
    return cookieValue? cookieValue[1] : null
    }

    let csrftoken = getCSRFToken()


    // undefined = hydrating
    // null = not authenticated
    // object = authenticated

    //NB null renders=> false
    //undefined renders=> false

    useEffect((e)=>{
          const token = JSON.parse(localStorage.getItem("UserAuthtoken"))
        console.log("Auth context is mounted")

        if (!token){
            //setSplashLoading(false)
            setIsAuthenticated(null)
            console.log("No token found for user")    
        }
       
        let func = async()=>{              

        try{
            let response = await axios.get("http://127.0.0.1:8000/djoser/users/me/", {
            headers:{
                'Authorization': `token ${token}`,
                'X-CSRFToken': csrftoken
            }
            })
            console.log("User identified:", response.data, "isAuthenticated:", isAuthenticated)
            setIsAuthenticated(response.data)
            setSuccessLogin(token)
            // navigate("/feed")
        }
        catch(error){
            console.log("Error identifying user", error)
            setIsAuthenticated(null)
        }
        finally{
            setSplashLoading(false)
            NProgress.done()
        }
        }

        func()

    }, [])
    


    //For external API
    let [externalUrl, setExternalUrl] = useState()
    let [albumImage, setAlbumImage] = useState()
    let [backHistory, setBackHistory] = useState()

    let data = {isAuthenticated, setIsAuthenticated, successLogin, setSuccessLogin, splashLoading, setSplashLoading, userInfo, setUserInfo, 
        searchResults, setSearchResults, category, setCategory, nextPageToken, setNextPageToken, setAttemptedPathToSession, consumeAttemptedPath,
        selected, setSelected, colorMode, setColorMode, toggleColorMode, isOnline,setIsOnline, doneUpdating, setDoneUpdating,
        isOpenDrawer, onCloseDrawer, onOpenDrawer
    }


    return(
        <div>
            <MyContext.Provider value={{...data}}> {/* All the children have access to the props provided here */}
                {children}
            </MyContext.Provider>
        </div>
    )
}






export default MyContextProvider;    // This is the major that gets use in App.js



